import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface GymContextType {
  selectedGymId: string | null; // GUID as string
  setSelectedGymId: (gymId: string | null) => void;
  getSelectedGymId: () => string | null;
}

const GymContext = createContext<GymContextType | undefined>(undefined);

export const useGymContext = () => {
  const context = useContext(GymContext);
  if (context === undefined) {
    throw new Error('useGymContext must be used within a GymProvider');
  }
  return context;
};

interface GymProviderProps {
  children: ReactNode;
}

export const GymProvider: React.FC<GymProviderProps> = ({ children }) => {
  const [selectedGymId, setSelectedGymIdState] = useState<string | null>(null);

  useEffect(() => {
    // Load saved gym selection on mount
    const savedGymId = localStorage.getItem('superadmin_selected_gym');
    if (savedGymId) {
      setSelectedGymIdState(savedGymId); // GUID as string, no parsing needed
    }
  }, []);

  const setSelectedGymId = (gymId: string | null) => {
    setSelectedGymIdState(gymId);
    if (gymId) {
      localStorage.setItem('superadmin_selected_gym', gymId);
    } else {
      localStorage.removeItem('superadmin_selected_gym');
    }
  };

  const getSelectedGymId = () => {
    return selectedGymId;
  };

  return (
    <GymContext.Provider value={{ selectedGymId, setSelectedGymId, getSelectedGymId }}>
      {children}
    </GymContext.Provider>
  );
};

